import React, { useMemo } from 'react'

import { PREFERENCES } from '../../user/constants'

import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import PowerOutagesLayer from '../../map/components/PowerOutagesLayer'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'
import MobileSidebar from '../../mobile/components/MobileSidebar'
import MobileBaseLayout from '../../mobile/components/MobileBaseLayout'
import MobileSiteSwitcher from '../../mobile/components/MobileSiteSwitcher'

const MobileLayout = () => {
  useUserPreferencesFetch() // fetch user's preferences

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      bottom: 75,
    }),
    []
  )

  return (
    <MobileBaseLayout title="Power Outages" basePath="/powerOutages">
      <MobileSidebar basePath="/powerOutages">
        <TabPanelContainer>
          <TabPanel path="/powerOutages/menu" component={MobileSiteSwitcher} />
        </TabPanelContainer>
      </MobileSidebar>
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Zoom position="none" />
        <PowerOutagesLayer />
      </Map>
    </MobileBaseLayout>
  )
}

export default MobileLayout
